// Shopify's gift card recipient line properties (spelled as Shopify reads
// them), plus our `Card design` name that the gift card email keys on.
export const GIFT_CARD_LINE = {
  sendToRecipient: '__shopify_send_gift_card_to_recipient',
  recipientEmail: 'Recipient email',
  recipientName: 'Recipient name',
  message: 'Message',
  sendOn: 'Send on',
  offset: '__shopify_offset',
  design: 'Card design',
} as const;
